module.exports = __webpack_public_path__ + "static/media/digital-marketing-introduce-bg.f0d53a9a.png";